import {MaterialStatusEnum} from "enums";

export const materialStatusOptions = [
  {uuid: MaterialStatusEnum.MARRIED, name: MaterialStatusEnum.MARRIED},
  {uuid: MaterialStatusEnum.LEGALLY_SEPARATED, name: MaterialStatusEnum.LEGALLY_SEPARATED},
  {uuid: MaterialStatusEnum.DIVORCED, name: MaterialStatusEnum.DIVORCED},
  {uuid: MaterialStatusEnum.NEVER_MARRIED, name: MaterialStatusEnum.NEVER_MARRIED},
  {uuid: MaterialStatusEnum.WIDOWED, name: MaterialStatusEnum.WIDOWED},
]